import React from 'react';
import Public from 'views/pages/authentication/auth-forms/public/Public';
const { FacebookProvider, CustomChat } = require('react-facebook');

const FacebookChat = () => {
    return (
        <Public>
            <FacebookProvider appId="376216901956409" chatSupport>
                <CustomChat pageId="1209474279112628" minimized={true} />
            </FacebookProvider>
        </Public>
    );
};

export default FacebookChat;
